/** Build the public Case Studies pagination URL without serializing an empty filter. */
export function buildCaseStudiesUrl(offset: number, limit: number, activeIndustry?: string) {
  const params = new URLSearchParams({
    offset: String(offset),
    limit: String(limit)
  });
  if (activeIndustry) {
    params.set("industry", activeIndustry);
  }
  return `/api/get-case-studies?${params.toString()}`;
}